import { Company, useCompanies } from 'src/secret-menu/hooks/useCompanies';
import PageLoader from 'src/UI/loader/PageLoader';
import React from 'react';
import { Flex, Select } from '@mantine/core';

export default function CompanyWrapper({
  contentComponent,
}: {
  contentComponent: React.ElementType<{ company: Company }>;
}) {
  const { companies, isLoading: isLoadingCompanies } = useCompanies();
  return isLoadingCompanies || !companies || companies.length === 0 ? (
    <PageLoader />
  ) : (
    <CompanyWrapperWithLoadedCompanies companies={companies} contentComponent={contentComponent} />
  );
}

function CompanyWrapperWithLoadedCompanies({
  companies,
  contentComponent: ContentComponent,
}: {
  companies: Company[];
  contentComponent: React.ElementType<{ company: Company }>;
}) {
  const [selectedCompany, setSelectedCompany] = React.useState<Company>(companies[0]);

  return (
    <Flex direction="column" gap="xxl">
      <Flex flex={1} justify={'flex-end'}>
        <Select
          label={'Company'}
          data={companies?.map(company => ({ label: company.name, value: company.id })) || []}
          value={selectedCompany.id}
          onChange={value =>
            setSelectedCompany(companies.find(c => c.id === value) || companies[0])
          }
          w={500}
        />
      </Flex>
      <ContentComponent company={selectedCompany} />
    </Flex>
  );
}
